import { useEffect, useMemo, useState } from "react"
import Modal from "../../components/Modal"
import DataTable from "../../Data/TablesData/Datatable"
import { useDatatableCtx } from "../../components/Datatable/DatatableContext"
import SimpleBackdropLoader from "../BackdropLoading/BackdropLoading"
import http from "../../http"
import { computeColumns } from "../../utils"
import { useFormat } from "../../context/FormatContext"
import { showError } from "../../utils/snackbar"
import { useLocalization } from "../../providers/LocalizationProvider"

const AlertLogs = ({
    showAlertLogsDialog,
    setShowAlertLogsDialog,
    alertId,
    setAlertId,
    alertNameTitle,
}) => {
    const [isLoading, setIsLoading] = useState(false)
    const [alertLogsTableData, setAlertLogsTableData] = useState([])
    const [alertLogsMetaData, setAlertLogsMetaData] = useState({})
    const { setRowData, setColumnMetaData: setColumnMetaData1 } = useDatatableCtx()
    const { formatDate } = useFormat()
    const { voiceiiTags } = useLocalization()
    const columns = useMemo(
        () =>
            computeColumns({
                data: alertLogsTableData,
                meta: alertLogsMetaData,
                action: ({ row, meta }) => {
                    setRowData(row)
                    setColumnMetaData1(meta)
                },
                formatDate,
            }),
        [alertLogsTableData],
    )

    const data = useMemo(() => alertLogsTableData, [alertLogsTableData])

    // Toggle MFA/2FA for user account API integration
    const getAlertLogsForSingleUser = async () => {
        setIsLoading(true)
        await http("GET", "api/v1/alerts/logs", {
            apiData: { alert_id: alertId },
        })
            .then((result) => {
                if (result.status) {
                    setAlertLogsTableData(result.data)
                    setAlertLogsMetaData(result.meta)
                    setIsLoading(false)
                } else {
                    setIsLoading(false)
                }
            })
            .catch((er) => {
                showError(er.message)
                setIsLoading(false)
            })
    }

    useEffect(() => {
        if (alertId) {
            getAlertLogsForSingleUser()
        }
    }, [alertId])

    return (
        <>
            <Modal
                fullWidth
                maxWidth="md"
                onClose={() => {
                    setShowAlertLogsDialog(false)
                    setAlertId("")
                    const datatableId = "alert_log_history"
                    const app = sessionStorage.getItem("app")
                    localStorage.setItem(
                        `${window.location.pathname + app + datatableId}_filter`,
                        JSON.stringify([]),
                    )
                    localStorage.setItem(
                        `${window.location.pathname + app + datatableId}_sort`,
                        JSON.stringify([]),
                    )
                    localStorage.setItem(
                        `${window.location.pathname + app + datatableId}_pageIndex`,
                        0,
                    )
                }}
                status={showAlertLogsDialog}
                disableSave={true}
            >
                <SimpleBackdropLoader showLoader={isLoading} />
                <DataTable
                    filteredResult={data}
                    datatableTitle={`${alertNameTitle} ${voiceiiTags("History")}`}
                    columns={columns}
                    data={data}
                    addActionName={voiceiiTags("New Asset Mapping")}
                    columnConfigKey={"alert_logs_columns_config"}
                    refreshAction={() => {
                        getAlertLogsForSingleUser()
                    }}
                    page_name="alert_logs"
                    id="alert_log_history"
                    showMapViewButton={false}
                    showAppLogoinTable={false}
                />
            </Modal>
        </>
    )
}

export default AlertLogs
